<template>
  <div class="page-container">
    <div class="page-header-container">
      <div class="header-left">
        <span class="header-left-back" @click="handleToBack">
          <i class="el-icon-arrow-left"></i> <span> 返回</span></span
        >
        <el-divider direction="vertical"></el-divider>
        <span class="header-left-text">我的面试</span>
      </div>
      <div class="header-center">面试详情</div>
      <div class="header-right">
        <el-link
          class="mr-12"
          :underline="false"
          href="https://jiker.feishu.cn/docs/doccnfwavjkQSSxrHTb4432imOh"
          target="_blank"
          ><i class="el-icon-question"></i
        ></el-link>
        <HeaderUser></HeaderUser>
      </div>
    </div>
    <div class="page-content-container">
      <div class="page-content-left" v-loading="loading">
        <div class="left-header">
          <div class="left-header-text">线上面试地址：</div>
          <el-link
            :underline="false"
            :href="interviewInfo.meeting_url"
            target="_blank"
            type="primary"
          >
            {{ interviewInfo.meeting_url }}</el-link
          >
          <div class="left-header-text" style=" color: #fa8c16;font-size:14px">
            （ 进入时间：{{ interviewInfo.start_at }} ）
          </div>
        </div>
        <div class="left-content" v-if="reportList.length">
          <el-tabs v-model="activeIndex">
            <el-tab-pane
              v-for="(item, index) in reportList"
              :key="item.type"
              :label="item.type"
              :name="String(index)"
            >
            </el-tab-pane>
          </el-tabs>
          <iframe
            :key="activeIndex"
            frameborder="0"
            style="width: 100%; height: calc(100% - 74px);"
            :src="`${reportList[activeIndex].report_url}#toolbar=0`"
          ></iframe>
        </div>
      </div>
      <div class="page-content-right" v-loading="loading">
        <div class="right-header">
          <div class="right-header-title">{{ interviewInfo.title }}</div>
        </div>
        <div class="right-content">
          <!-- <div class="flex">
            <div class="info">面试岗位：</div>
            <div>{{ interviewInfo.job_name }}</div>
          </div>
          <div class="flex">
            <div class="info">级别：</div>
            <div>{{ interviewInfo.require_level }}</div>
          </div> -->
          <el-form ref="form" :model="formData" label-width="100px">
            <el-form-item label="面试岗位：">
              {{ interviewInfo.job_name }}</el-form-item
            >
            <el-form-item label="级别：">
              {{ interviewInfo.require_level }}</el-form-item
            >
            <el-form-item label="推荐度：" required prop="recommend_level">
              <el-radio-group
                v-model="formData.recommend_level"
                :disabled="interviewInfo.status == 3"
                size="mini"
              >
                <el-radio-button
                  v-for="(item, index) in recommendList"
                  :label="index"
                  :key="item"
                  >{{ item }}
                </el-radio-button>
              </el-radio-group></el-form-item
            >
            <el-form-item label="面试评价：" required prop="comment">
              <el-input
                :disabled="interviewInfo.status == 3"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6 }"
                placeholder="请输入内容"
                v-model="formData.comment"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="面试结论："
              required
              prop="comment"
              v-if="interviewInfo.status == 3"
            >
              <span
                :style="
                  `color:${
                    interviewInfo.result == 'pass' ? '#67C23A' : '#F56C6C'
                  }`
                "
                >{{ interviewInfo.result == "pass" ? "通过" : "不通过" }}
              </span>
            </el-form-item>
          </el-form>
          <!-- <el-button plain>通过</el-button>
          <el-button type="primary" plain>不通过</el-button> -->
          <div
            style="padding-left:100px;margin-top:40px"
            v-if="interviewInfo.status != 3"
          >
            <div
              @click="handleSubmit('pass')"
              class="right-btn"
              style="margin-right:18px"
            >
              <i class="el-icon-check"></i>
              通过
            </div>
            <div @click="handleSubmit('reject')" class="right-btn refuse">
              <i class="el-icon-close"></i>
              不通过
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import interviewService from "@/global/service/interview";
import HeaderUser from "@/components/HeaderUser.vue";

export default {
  computed: {
    ...mapState(["userAvatar", "userName", "authPermissions"])
  },
  components: {
    HeaderUser
  },
  mounted() {},
  data() {
    return {
      uuid: this.$route.params.uuid,
      interviewInfo: {},
      activeIndex: 0,
      reportList: [],
      formData: {
        comment: "",
        recommend_level: ""
      },
      loading: true,
      recommendList: [
        "1 - 非常不推荐",
        "2 - 不推荐",
        "3 - 中等",
        "4 - 推荐",
        "5 - 强烈推荐"
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      interviewService.getInterviewInfo(this.uuid).then(res => {
        this.interviewInfo = res;
        this.reportList = res.candidate.resume
          ? [
              { type: "个人简历", report_url: res.candidate.resume },
              ...res.candidate.reports
            ]
          : res.candidate.reports;
        if (res.status != 2) {
          this.formData.comment = res.comment;
          this.formData.recommend_level = res.recommend_level;
        }

        setTimeout(() => {
          this.loading = false;
        }, 1000);
        let now = new Date().getTime();
        let target = new Date(res.start_at).getTime();
        let diff = Math.floor((target - now) / 1000);
        if (diff > 1800) {
          this.startCountdown(diff);
        }
      });
    },
    startCountdown(duration) {
      let remainingMilliseconds = duration * 1000;
      let that = this;
      let timer = setInterval(function() {
        remainingMilliseconds -= 1000;
        if (remainingMilliseconds == 1800000) {
          clearInterval(timer);
          that.getData();
        }
      }, 1000);
    },
    handleToBack() {
      this.$router.back();
    },
    handleSubmit(result) {
      const params = {
        result,
        ...this.formData
      };
      interviewService.interviewResult(this.uuid, params).then(() => {
        this.$message.success("提交成功！");
        this.getData();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
}
/deep/.el-tabs__content {
  height: 100%;
}
.page-container {
  position: relative;
  min-width: 1440px;
  height: 100vh;
  width: 100%;
  min-width: 1440px;
  background: #f2f3f5;
  .page-header-container {
    padding: 20px 24px;
    width: 100%;
    height: 72px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(217, 217, 217, 0.83);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .header-center {
      position: absolute;
      left: 50%;
      line-height: 70px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
    .header-left {
      .header-left-back {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        &:hover {
          color: rgba(0, 0, 0, 0.65);
        }
      }
      .header-left-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      .page-header-right {
        display: flex;
        align-items: center;
        padding: 0 20px;
        height: 100%;
        transition: all 0.2s ease;
        cursor: pointer;
        // &:hover {
        //   background: #ecf5ff;
        // }
        .user-avatar {
          margin-right: 12px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
        .user-name {
          margin-right: 12px;
          font-size: 14px;
        }
      }
    }
  }
  .page-content-container {
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 72px);
    .page-content-left {
      width: 62%;
      height: 100%;
      .left-content {
        background: #fff;
        height: calc(100% - 56px);
        padding: 0 24px;
      }
      .left-header {
        width: 100%;
        height: 56px;
        background: #fafafa;
        padding: 0 24px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        .left-header-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #262626;
        }
      }
      .left-content {
        border-right: 1px solid #e5e5e5;
        height: calc(100% - 56px);
        .tree-container {
          height: 100%;
          background: #ffffff;
          padding: 24px;
          overflow-y: auto;
          .custom-tree-node {
            width: 100%;
            padding-right: 8px;
            justify-content: space-between;
            .tree-info-text {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              &.none {
                color: #c9c9c9;
              }
              &.default {
                color: #68718e;
              }
              &.success {
                color: #53bd6f;
              }
              &.error {
                color: #f67e7e;
              }
              &.orange {
                color: #fa8c16;
              }
            }
            .tree-label {
              .tree-label-title {
                font-size: 14px;
              }
            }
            .tree-operation {
              color: rgba(0, 0, 0, 0.85);
              margin-right: 4px;
              &.add:hover {
                color: #409eff;
              }
              &:hover {
                color: #f56c6c;
              }
            }
            .tree-label-icon {
              right: 16px;
            }
          }
        }
      }
    }
    .page-content-right {
      width: 38%;
      height: 100%;
      .right-header {
        width: 100%;
        height: 56px;
        background: #fafafa;
        border-bottom: 1px solid #e5e5e5;
        border-left: 1px solid #e5e5e5;
        padding: 16px 24px;
        justify-content: space-between;
        position: relative;
        .right-header-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 24px;
        }
      }
      .right-content {
        overflow-y: auto;
        border-left: 1px solid #e5e5e5;
        height: calc(100% - 56px);
        width: 100%;
        background: #fff;
        padding: 32px;
        .info {
          width: 70px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 500;
        }
        .text {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          font-weight: 500;
        }
        .right-content-box {
          height: 100%;
          .right-content-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #bfbfbf;
            margin-bottom: 10px;
          }
          .right-content-markdown {
            height: 84%;
            /deep/.markdown-body {
              height: 100% !important;
            }
          }
          .right-content-foot {
            margin-top: 18px;
            justify-content: space-between;
            .right-content-btn {
              height: 40px;
              width: 160px;
              padding: 4px;
              font-size: 16px;
            }
            .right-content-annex {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.45);
            }
          }
        }
      }
    }
  }
}
/deep/.el-radio-button__inner {
  padding: 7px;
}
.right-btn {
  display: inline-flex;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #00955b;
  font-weight: 500;
  font-size: 14px;
  color: #00955b;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: #52c41a80;
    color: #52c41a80;
  }
  i {
    font-size: 16px;
    margin-right: 6px;
  }
  &.refuse {
    color: #ff4d4f;
    border-color: #ff4d4f;
    &:hover {
      color: #ff7875;
      border-color: #ffa39e;
    }
  }
  // /deep/ i {
  //   font-size: 14px;
  // }
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
</style>
